import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up",
  style: {"width":"auto"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"20px","display":"flex"}
}
const _hoisted_5 = {
  key: 1,
  style: {"margin-bottom":"35px"}
}
const _hoisted_6 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"green","font-weight":"bold"}
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  id: "playbook-sheet",
  class: "playbook-sheet"
}
const _hoisted_10 = ["onContextmenu"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "form-close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = () => { _ctx.$emit('close') })
            }, "×")
          ]),
          (_ctx.$store.state.user.teamHubRole == 'Admin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "add-btn",
                      onClick: _cache[1] || (_cache[1] = () => { _ctx.editing = true; })
                    }, "Edit"))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "add-btn",
                      onClick: _cache[2] || (_cache[2] = () => { _ctx.editing = false; })
                    }, "Stop Editing"))
              ]))
            : _createCommentVNode("", true),
          (_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.saving)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Saving..."))
                  : (_ctx.saved)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "All Changes Saved."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, " "))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "playbook-sheet-wrap company-sheet-wrap team-hub-sheet-wrap",
            style: _normalizeStyle(_ctx.editing ? 'overflow:visible;max-height:100%!important;' : 'overflow:visible;max-height:100%!important;pointer-events:none!important')
          }, [
            _createElementVNode("table", _hoisted_9, [
              _createVNode(_component_draggable, {
                list: _ctx.formData.sheetJSON.rows,
                tag: "tbody",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.debounceSubmit()))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.sheetJSON.rows, (row, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'r'+i
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: 'c'+j,
                          onContextmenu: ($event: any) => (_ctx.cellRightClick($event, i, j)),
                          class: _normalizeClass('playbook-sheet-cell-' + col.style)
                        }, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((col.text) = $event),
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.debounceSubmit())),
                              spellcheck: "false"
                            }, null, 40, _hoisted_11), [
                              [_vModelText, col.text]
                            ])
                          ])
                        ], 42, _hoisted_10))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRightClickMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "form-wrapper link-pop",
          style: _normalizeStyle(`top: ${_ctx.rightClickY - 20}px; left: ${_ctx.rightClickX}px`)
        }, [
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[5] || (_cache[5] = () => { _ctx.showRightClickMenu = false })
            }, "×")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.addRow(_ctx.rightClickCellRow)), ["prevent"]))
            }, "Add Row Above")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.addRow(_ctx.rightClickCellRow + 1)), ["prevent"]))
            }, "Add Row Below")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.addCol(_ctx.rightClickCellCol)), ["prevent"]))
            }, "Add Col Left")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.addCol(_ctx.rightClickCellCol + 1)), ["prevent"]))
            }, "Add Col Right")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.removeRow(_ctx.rightClickCellRow)), ["prevent"]))
            }, "Delete Row")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.removeCol(_ctx.rightClickCellCol)), ["prevent"]))
            }, "Delete Col")
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].style) = $event)),
              style: {"margin":"0"},
              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.menuValueChange()))
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("option", { value: undefined }, "Regular", -1),
              _createElementVNode("option", { value: "red" }, "Primary", -1),
              _createElementVNode("option", { value: "gray" }, "Gray", -1),
              _createElementVNode("option", { value: "noborder" }, "No Border", -1)
            ]))], 544), [
              [_vModelSelect, _ctx.formData.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].style]
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.showConfirmColRemove)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 2,
          onConfirm: _ctx.removeColCB,
          onCancel: _cache[14] || (_cache[14] = () => { _ctx.showConfirmColRemove = false; }),
          msg: "Are you sure you would like to delete this col?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmRowRemove)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 3,
          onConfirm: _ctx.removeRowCB,
          onCancel: _cache[15] || (_cache[15] = () => { _ctx.showConfirmRowRemove = false; }),
          msg: "Are you sure you would like to delete this row?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}